module.exports = __webpack_public_path__ + "img/PeepsProne.01dcae27.svg";